import { alpha, Box, makeStyles, Tooltip, Typography } from '@material-ui/core';
import dayjs from 'dayjs';

import { ReactComponent as IASummaryIcon } from 'assets/images/assistant-icon.svg';

import MessageBase, { MessageBaseProps } from './MessageBase';
import MessageErrorFallback from './MessageErrorFallback';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    padding: theme.spacing(1),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  title: {
    fontWeight: 600,
    fontSize: 12,
  },
  message: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  time: {
    textAlign: 'right',
    color: alpha(theme.palette.common.black, 0.5),
  },
}));

type IASummaryMessageProps = MessageBaseProps;

export default function IASummaryMessage(props: IASummaryMessageProps) {
  const classes = useStyles();

  try {
    const { mensagem } = props;

    const createdAt = dayjs(mensagem.criadoEm);
    const fullDate = createdAt.format('D [de] MMM [de] YYYY [às] HH:mm');
    const shortTime = createdAt.format('HH:mm');

    return (
      <MessageBase maxWidth="100%" width="500px" {...props}>
        <Box className={classes.root}>
          <Box className={classes.header}>
            <Typography className={classes.title}>
              Resumo gerado por IA
            </Typography>
            <IASummaryIcon />
          </Box>

          <Typography variant="body2" className={classes.message}>
            {mensagem.mensagem}
          </Typography>

          <Box className={classes.footer}>
            <Tooltip arrow placement="bottom" title={fullDate}>
              <Typography variant="caption" className={classes.time}>
                {shortTime}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
      </MessageBase>
    );
  } catch (error) {
    return <MessageErrorFallback {...props} />;
  }
}
